import { render, staticRenderFns } from "./PackingHousesinDialog.vue?vue&type=template&id=21d974b3"
import script from "./PackingHousesinDialog.vue?vue&type=script&lang=js"
export * from "./PackingHousesinDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports